import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DonorRecruitmentCampaignImpactChart from "./DonorRecruitmentCampaignImpactChart";

// Static data for donor recruitment campaign impact
const STATIC_CAMPAIGN_DATA = {
  months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  afterCampaign: [120, 145, 132, 168, 195, 210, 185, 220, 198, 245, 230, 275],
  beforeCampaign: [95, 118, 105, 140, 165, 178, 155, 190, 170, 210, 195, 240],
};

const DonorRecruitmentCampaignImpactWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={12} lg={12}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Donor Recruitment Campaign Impact")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <DonorRecruitmentCampaignImpactChart data={STATIC_CAMPAIGN_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default DonorRecruitmentCampaignImpactWrapper;
